var map = {
	"./001.jpg": "8382",
	"./002.png": "bc04",
	"./003.png": "7d4d",
	"./AI.jpg": "47b7",
	"./AI_book.jpg": "a240",
	"./bluetooth_smartpen.png": "5d52",
	"./digitalIllustrate.jpg": "4f72",
	"./download1.png": "f646",
	"./download2.png": "fc47",
	"./error01.png": "5663",
	"./error02.png": "406f",
	"./error03.png": "5859",
	"./error339.png": "7dbc",
	"./livepen2025_01.jpg": "5b53",
	"./livepen2025_02.jpg": "6c60",
	"./markingAssignments1.png": "e16f",
	"./markingAssignments2.png": "6312",
	"./mp3download.png": "ad89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0970";